<template>
  <div class="component-wrap" :class="{'component-padded' : base.padded, 'active': active}">
    <div class="current-active"></div>
    <div v-if="base.title" class="component-header">
      <div class="component-title">
        <div>专题配置</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      res: {
        type: Object,
        default: {}
      },
      active: {
        type: Boolean,
        default: false
      }
    }, 
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
          }
        }
      }
    },
    data () {
      return {
        base: {},
        data: [],
        config:[],
      }
    },
    methods: {
      setData(val) {
        this.base = val.base
        this.data = val.data
        this.name = val.name
        this.config=val.config
      }
    },
    mounted() {
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">
  .coupon-component {
    position: relative;
    display: flex;
    align-items: center;
    position: relative;
    padding: 12.5px 17.5px;
    margin-bottom: 5px;
    z-index: 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// special.vue?b261e04e